module.exports = __webpack_public_path__ + "img/18a001-07.fbf1fb5e.jpg";